var exports = {
  "WB": "GroupDMWelcomeSection.module__welcomeSection___VFFkYm",
  "rZ": "GroupDMWelcomeSection.module__profileSection___VFFkYm",
  "hv": "GroupDMWelcomeSection.module__groupName___VFFkYm",
  "Yh": "GroupDMWelcomeSection.module__welcomeText___VFFkYm",
  "o1": "GroupDMWelcomeSection.module__actions___VFFkYm",
};

module.exports = exports;
